var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5",attrs:{"id":"page-shortlink"}},[_c('p',[_vm._v("Redirecting shortlink... "+_vm._s(_vm.linkstr))])])
}
var staticRenderFns = []

export { render, staticRenderFns }